module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIzNzA4ZWMyMzY5ODVlM2NiY2YzNzU5YTFkZDJmZjQwYi5wbmciOw=="